import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { CustomChannelProps } from "../../../../../types/customChannel";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditServiceLevel: (id: number | string) => void;
  onDeleteServiceLevel: (id: number | string) => void;
  onViewServiceLevel: (id: number | string) => void;
  data: CustomChannelProps[];
  [x: string]: any;
}
export default function DataTable({
  onEditServiceLevel,
  onDeleteServiceLevel,
  onViewServiceLevel,
  data,
  userValidation,
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Custom Channel - Maintenance") ||
            hasClaim("Custom Channel - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_CANAL}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewServiceLevel(row.ID_CANAL)}
        color="inherit"
        data-testid="view-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Custom Channel - Maintenance") ? "block" : "none",
        }}
        key={`edit-${row.ID_CANAL}`}
        icon={<EditIcon />}
        label="Edit"
        className="textPrimary"
        onClick={() => onEditServiceLevel(row.ID_CANAL)}
        color="inherit"
        data-testid="edit-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Custom Channel - Maintenance") ? "block" : "none",
        }}
        key={`delete-${row.ID_CANAL}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteServiceLevel(row.ID_CANAL)}
        color="inherit"
        data-testid="delete-button"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "DESCRICAO",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "CODIGO_EDI",
      headerName: "EDI Code",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "ATIVO",
      headerClassName: "super-app-theme--header",
      headerName: "Status",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data.map((row) => row.ID_CANAL)}
        data-testid="service-level-data-table"
        data={data}
        columns={columns}
        {...props}
      />
    </>
  );
}
